import React, { FC } from 'react'
import { Link } from 'react-scroll'
import styles from 'styles/components/error.module.scss'
import { Spacer } from 'components/Utility'

type Props = {
  caution: string
  id?: string
}

const ErrorMessage: FC<Props> = (props) => {
  const { caution, id } = props
  return (
    <Link to={id ?? ''} smooth={true} offset={-95} duration={750}>
      <div className={styles.error__message}>
        <img src={'/icon/red/arrow_error.svg'} alt={''} />
        <Spacer size={4} axis={'horizontal'} />
        <p>{caution}</p>
      </div>
    </Link>
  )
}

export default ErrorMessage
